import $ from 'cash-dom'

$('.faq-trigger').on('click', (e) => {
  const $el = $(e.currentTarget)
  $el.find('svg').toggleClass('transform rotate-180')
  $el.siblings().each(function () {
    $(this).toggleClass('hidden')
  })
})
